import { useNavigate } from "react-router-dom";
import LogoComment from "src/assets/images/logo/logoblack.png";
import { classNames } from "src/helpers/mixins";
import { ParamsCardWall } from "src/types";

const CardWall: React.FC<ParamsCardWall> = ({
  autor,
  description,
  title,
  link,
  children,
  type,
  createdAt,
  photoUrl,
  multimediaUrl,
  likes,
  views,
}) => {
  const navigate = useNavigate();

  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      onClick={() => link ? navigate(link) : undefined}
      className={classNames(
        link ? 'cursor-pointer transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl' : '',
        'relative bg-gradient-to-br from-white via-gray-50 to-white mb-6 rounded-xl shadow-lg border border-gray-100 overflow-hidden group'
      )}
    >
      {/* Header con gradiente */}
      <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 px-6 pt-4 pb-2">
        <div className="flex items-center gap-3">
          <div className="relative">
            <img
              src={photoUrl || LogoComment}
              alt="isf"
              className="w-10 h-10 border-2 border-white rounded-full object-cover shadow-md"
            />
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <span className="font-bold text-white text-lg">{autor}</span>
              {title && (
                <span className="text-blue-100 font-medium">{title}</span>
              )}
            </div>
            {createdAt && (
              <p className="text-blue-200 text-xs mt-1">
                {formatDate(createdAt)}
              </p>
            )}
          </div>
          {link && (
            <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          )}
        </div>
      </div>

      {/* Contenido principal */}
      <div className="px-6 pb-5">
        <div className="text-gray-700 leading-relaxed mb-4">
          {typeof description === 'string' ? (
            <p className="text-gray-700 font-medium">{description}</p>
          ) : (
            description
          )}
        </div>
        
        {children && (
          <div className="mt-4">
            {children}
          </div>
        )}

 

        {/* Footer con estadísticas */}
        {(likes !== undefined || views !== undefined) && (
          <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
            <div className="flex items-center gap-4">
              {likes !== undefined && (
                <div className="flex items-center gap-1 text-gray-500">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm font-medium">{likes}</span>
                </div>
              )}
              {views !== undefined && (
                <div className="flex items-center gap-1 text-gray-500">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm font-medium">{views}</span>
                </div>
              )}
            </div>
            
            {type && (
              <span className="px-3 py-1 bg-gradient-to-r from-blue-500 to-purple-500 text-white text-xs font-semibold rounded-full">
                {type}
              </span>
            )}
          </div>
        )}
      </div>

      {/* Efecto de brillo en hover */}
      {link && (
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
      )}
    </div>
  );
};

export default CardWall;
